<template>
    <div class="page bgF5F5F5" style="max-width: 425px;">

        <div style="line-height: 28px;">
            <header class="pageHeader paddingH16 paddingV8 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                            <img class="icon shareIcon size22" src="icon/black_share_icon.png" style="margin-top: 3px;"
                                 @click="share()"/>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body bgEEE" style="
            padding-top: 170px;
            background-size: 100% 204px;
            background-repeat: no-repeat;"
             :style="dataItem && dataItem.coverImg ? 'background-image: url(' + dataItem.coverImg + ')' : ''">
            <div class="white_bg" style="border-radius: 16px 16px 0px 0px;">

                <div class="paddingH16 marginB8 lecturerInfo" style="padding-top: 22px; padding-bottom: 16px">
                    <div class="flexLayout">
                        <div style="width: 64px;">
                            <div class="imageArea size64 circle hiddenOverflow">
                                <img class="fullSpace" :src="dataItem.userHead" v-if="dataItem && dataItem.userHead"/>
                            </div>
                        </div>
                        <div class="flexItem marginL12">

                            <!-- teacher name -->
                            <div style="padding: 13px 0 9px;">
                                <span class="font18r grey20 bold">{{dataItem ? dataItem.teacherName : ''}}</span>
                                <span class="font14r brown marginL8">/{{dataItem ? dataItem.ipName : ''}}</span>
                            </div>

                            <div class="font12r hiddenOverflow textOverflowShowEllipsis"
                                 style="color: #5B616C; line-height: 1.5em; height: 1.5em;">
                                {{dataItem ? dataItem.signature : ''}}
                            </div>

                        </div>
                    </div>

                    <div class="flexLayout alignC" style="padding: 32px 0;">
                        <div class="flexItem">
                            <strong class="bold font24r color333">{{dataItem ? dataItem.courseCount || 0 : '...'}}</strong>
                            <span class="grey font12r marginL4" style="vertical-align: baseline">课程总数</span>
                        </div>
                        <div class="flexItem">
                            <strong class="bold font24r color333">{{dataItem ? dataItem.applyCount || 0 : '...'}}</strong>
                            <span class="grey font12r marginL4" style="vertical-align: baseline">课程热度</span>
                        </div>
                    </div>

                    <div class="font12r color333 lineHeight21r12f descArea hiddenOverflow"
                         :class="{collapsed : desc.collapsed}">
                        简介：
                        <article class="article" v-html="dataItem ? dataItem.introduce : ''"></article>
                    </div>
                    <div class="alignR font12r">
                        <span style="color:#8994A9" v-show="desc.collapsed" @click="desc.collapsed=!desc.collapsed">
                            展开
                            <i class="icon greyDownAngleIcon" style="width: 10px; height: 10px;"></i>
                        </span>
                        <span style="color:#8994A9" v-show="!desc.collapsed" @click="desc.collapsed=!desc.collapsed">
                            收起
                            <i class="icon greyUpAngleIcon" style="width: 10px; height: 10px;"></i>
                        </span>
                    </div>
                </div>

            </div>

            <div class="white_bg paddingH16 marginT8">
                <div class="paddingV16 font18r bold color333">
                    讲师课程
                </div>
                <div class="list">
                    <div class="item" style="margin-bottom: 32px;" v-for="courseItem in dataList"
                         :key="courseItem.id" @click="viewCourse(courseItem)">

                        <div class="inner flexLayout">
                            <div style="width: 124px">
                                <div class="imageArea roundBorder8 w100p hiddenOverflow" style="height: 78px;">
                                    <img class="cover fullSpace" :src="courseItem.coverImg" v-if="courseItem.coverImg"/>
                                </div>
                            </div>
                            <div class="flexItem paddingL8">
                                <div class="titleArea font14r grey20 bold lineHeight21r14f" style="margin-bottom: 16px;">
                                    {{courseItem.title}}
                                </div>

                                <div class="font12r grey marginT16">
                                    {{dataItem ? dataItem.teacherName : ''}}
                                </div>

                                <div class="clearfix font12r marginT16">
                                    <div class="fl bold grey20">
                                        <span class="red">￥</span>
                                        <span class="red font16r12">{{courseItem.price}}</span>
                                        <span v-show="courseItem.liveCount">
                                            /共{{courseItem.liveCount}}节
                                        </span>
                                    </div>
                                    <div class="learningArea fr grey20">
                                        {{courseItem.applicantCount + courseItem.applicantCountSham}}人在学
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'ready' &&  dataList.length < 1">
                        暂无任何课程
                    </div>

                    <div class="paddingV16 alignCenter font14r colorCCC"
                         v-show="status=='ready' && pagination.current == pagination.totalPage"
                         :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                        没有更多课程了
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'error'">
                        加载数据失败
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// util
import appHelper    from '@/util/appHelper';
import stringHelper from '@/util/stringHelper';
import consoleApi   from '@/components/platformApi/consoleApi';
import numberHelper from "@util/numberHelper";
import arrayHelper  from "@util/arrayHelper";

const config = {
    name : 'lecturerDetailPage',
    title : '讲师详情',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/teacher/v2/info',
            dataColumnMapping : {
                // userName : 'name'
            }
        },
        list : {
            url : '/portal/user/teacher/listCourse',
            params : {
                id : '',
                courseType : 'VOD'
            },
            dataPath : 'data.rows',
            totalPath : 'data.totalCount',
            totalPagePath : 'data.totalPage',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            enableDataList : true,
            autoLoadDataItem : true,
            autoLoadDataList : false,

            desc : {
                collapsed : true
            }
        }
    },
    methods : {
        onLoadDataItem : function () {

            this.title = this.dataItem.teacherName;

            appHelper.setTitle(this.title);

            this.setWechatShare();

            this.apiConfig.list.params.id = this.dataItem.userId;
            this.loadDataList();
        },
        viewCourse(courseItem) {  
            appHelper.goToPage('courseDetail', {
                id : courseItem.id
            });
        }
    },
    mounted() {

        if (appConfig.mode === 'demo')
        {
            this.dataItem = {
                id : 1,
                title : '',
                teacherName: stringHelper.getRandomNickName(),
                coverImg : appHelper.getRandomCoverImage(),
                userHead : appHelper.getRandomCoverImage(),
                signature : '没有做不到的，只有想不到的想不到的想不到的...',
                desc : '专注亲子幼儿，园所管理、拥有十几年的幼教经验，为千万幼师解决职业难题，深受学员喜爱。专注亲子幼儿，园所管理、拥有十几年的幼教经验，为千万幼师解决职业难题，深受学员喜爱。',
                courseCount : numberHelper.getRandomInteger(20),
                applyCount : numberHelper.getRandomInteger(1500),
            };

            for (let i=1; i<=8; i++)
            {
                this.dataList.push({
                    id : i,
                    title : arrayHelper.getRandomItem(config.demoTitleList),
                    teacherName: stringHelper.getRandomNickName(),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    createTime : new Date().getTime() - numberHelper.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                    price : numberHelper.getRandomInteger(60),
                    segCount : numberHelper.getRandomInteger(60),
                    applyCount : numberHelper.getRandomInteger(60),
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.brown {
    color: #C9821A;
}
.grey {
    color: #8994A9;
}
.lecturerInfo {
    .descArea {
        &.collapsed {
            height: 3.5em;
        }
        p {
            margin: 0;
        }
    }
}
.list {
    .item {
        &:last-child {
            margin-bottom: 0;
        }
    }
    .titleArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .descArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 16px;
    }
}
</style>
